import {PageWrapper} from "../common/PageWrapper";
import {useAppSelector} from "../../hooks/redux";
import {EditorRef, EmailEditor, EmailEditorProps} from "react-email-editor";
import {useRef} from "react";

export default function CreateEmail () {

    const { currentHotel } = useAppSelector(state => state.hotels)

    const emailEditorRef = useRef<EditorRef>(null);

    const exportHtml = () => {
        const unlayer = emailEditorRef.current?.editor;

        unlayer?.exportHtml((data: any) => {
            const { design, html } = data;
            console.log('exportHtml', html);
        });
    };

    const onReady: EmailEditorProps['onReady'] = (unlayer) => {
        // editor is ready
        // you can load your template here;
        // the design json can be obtained by calling
        // unlayer.loadDesign(callback) or unlayer.exportHtml(callback)
        // const templateJson = { DESIGN JSON GOES HERE };
        // unlayer.loadDesign(templateJson);
    };

    return (
        <div className={'h-full flex flex-col'}>
            <EmailEditor style={{ flex: 1, width: '100%' }} ref={emailEditorRef} onReady={onReady} />
        </div>
    )

}
